import { Button, Col, FormFeedback, FormGroup, Input, Label } from "reactstrap";
import useForm, { ICallbackSubmit } from "src/hooks/useForm";
import useLazyFetch from "src/hooks/useLazyFetch";
import * as yup from "yup";

interface IProps {
  initialValues?: {
    id?: number | string;
    name: string;
    device_id: string;
  } | null;
  onClose?: () => void;
  onReload?: () => void;
  isEdit?: boolean;
}

const AddEditBridge = ({
  initialValues = null,
  onClose = () => null,
  onReload = () => null,
  isEdit = false,
}: IProps) => {
  const [onAdd] = useLazyFetch({
    url: "https://api.automa.id/api/iot/lock/bridges/add",
    method: "POST",
  });
  const [onEdit] = useLazyFetch({
    url: "https://api.automa.id/api/iot/lock/bridges/edit",
    method: "POST",
  });
  const validation = () => {
    return yup.object().shape({
      name: yup.string().required("Name is required"),
      device_id: yup.string().required("Device ID is required"),
    });
  };
  const {
    handleSubmit,
    errors,
    handleChange,
    values,
    isSubmitting,
    handleReset,
    isValid,
  } = useForm({
    initialValues: {
      name: !!initialValues ? initialValues.name : "",
      device_id: !!initialValues ? initialValues.device_id : "",
    },
    validation: validation(),
  });
  const onSubmit: ICallbackSubmit = (values, { setSubmitting }) => {
    (isEdit ? onEdit : onAdd)(
      {
        body: {
          name: values.name,
          device_id: values.device_id,
        },
        ...(isEdit ? { path: "/" + initialValues?.id } : {}),
      },
      (res, err) => {
        setSubmitting(false);
        if (!!!err && !!res) {
          onReload();
          onClose();
        }
      }
    );
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormGroup row>
          <Col md="3">
            <Label htmlFor="name">Name</Label>
          </Col>
          <Col xs="12" md="9">
            <Input
              type="text"
              name="name"
              id="name"
              placeholder="Name"
              autoComplete="off"
              valid={!errors.name}
              invalid={!!errors.name}
              onChange={handleChange}
              value={values.name}
              disabled={isSubmitting}
            />
            <FormFeedback>{errors.name}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md="3">
            <Label htmlFor="name">Device ID</Label>
          </Col>
          <Col xs="12" md="9">
            <Input
              type="text"
              name="device_id"
              id="device_id"
              placeholder="Device ID"
              autoComplete="off"
              valid={!errors.device_id}
              invalid={!!errors.device_id}
              onChange={handleChange}
              value={values.device_id}
              disabled={isSubmitting}
            />
            <FormFeedback>{errors.device_id}</FormFeedback>
          </Col>
        </FormGroup>

        <FormGroup>
          <div className="d-flex justify-content-end w-100">
            <Button
              type="reset"
              color="danger"
              className="mr-1 w-25"
              disabled={isSubmitting}
              onClick={handleReset}
            >
              Reset
            </Button>
            <Button
              type="button"
              color="warning"
              className="mr-1 w-25"
              disabled={isSubmitting}
              onClick={() => onClose()}
            >
              Close
            </Button>

            <Button
              type="submit"
              color="primary"
              className="mr-1 w-50"
              disabled={isSubmitting || !isValid}
            >
              {isSubmitting ? "Wait..." : "Submit"}
            </Button>
          </div>
        </FormGroup>
      </form>
    </>
  );
};

export default AddEditBridge;
